<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Connections / Integrations') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">
      <creating
        v-if="creating"
        height="100%" />

      <div
        v-else
        class="shurt-conatiner"
        :class="{'box-loading': loading}">

        <!-- Connections -->
        <div
          v-if="connections.length"
          class="mb-4">
          <h6 class="subtext mb-2">{{ $t('Your connections') }}</h6>
          <ul class="list-group">
            <ConnectionItem
              v-for="(connection, index) in connections"
              :key="connection._id || connection.id || connection.connection_id || index"
              :connection="connection" />
          </ul>
        </div>

        <!-- Providers -->
        <h6 class="subtext mb-2">{{ $t('Available integrations') }}</h6>
        <NoResults v-if="!integrations.length">
          {{ $t('There are no items') }}
        </NoResults>
        <ul
          v-else
          class="list-group">
          <IntegrationItem
            v-for="(integration, index) in integrations"
            :key="integration.integration || index"
            :integration="integration"
            :connected="isConnected(integration)"
            @connected="loadConnections()" />
        </ul>

      </div>
    </div>

  </div>

</template>

<script>
import IntegrationItem from './IntegrationItem'
import ConnectionItem from './ConnectionItem'

export default {
  name: 'Integrations',
  components: {
    IntegrationItem,
    ConnectionItem
  },
  data () {
    return {
      creating: true,
      loading: false
    }
  },
  computed: {
    integrations () {
      return this.$store.getters.getIntegrationProviders
    },
    connections () {
      return this.$store.getters.getConnections
    }
  },
  metaInfo () {
    return {
      title: this.$t('Connections / Integrations')
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    isConnected
    indica se a integração já possui uma conexão criada
    */
    isConnected (integration) {
      return this.connections.some((connection) => {
        return connection.integration === integration.integration
      })
    },
    /*
    loadData
    */
    loadData () {
      this.loading = true

      Promise.all([
        this.$store.dispatch('selectConnections'),
        this.$store.dispatch('selectIntegrationProviders')
      ])
      .then(() => {
        this.loading = this.creating = false
      })
      .catch(() => {
        this.loading = this.creating = false
      })
    },
    /*
    loadConnections
    reloads only the connections list (e.g. after a new connection is created)
    */
    loadConnections () {
      this.loading = true

      this.$store
      .dispatch('selectConnections')
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integrations/Integrations.vue